// extracted by mini-css-extract-plugin
export var modal = "_tt-0";
export var table = "_tt-1";